module.exports = __webpack_public_path__ + "media/assets/cross-with-circle-border-87bedcf4d8306b22bef2e89ecd92cc9076056bffdc8a54f843e12e6557946852.svg";